import { createSlice } from '@reduxjs/toolkit'
import {
  createApiThunkPublic,
  createExtraReducersForThunk
} from '../../utils/apiThunk'

const initialState = {
  value: 0
}

export const login = createApiThunkPublic('login', '/login')

export const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {},
  extraReducers: builder => {
    createExtraReducersForThunk(builder, login, 'login')
  }
})

export default counterSlice.reducer
